const sectionTotal = (section) => section?.externalTotal ?? section?.total ?? 0;

export const splitShortfall = (calculated, offer, budget) => {
  const summary = calculated?.showSummary;
  if (!summary) return null;

  const operator = summary.dollarOrPercentageOperator ?? budget?.dollar_or_percentage_operator;
  const fromDollarOne = summary.fromDollarOne ?? budget?.from_dollar_one;
  const dealBrackets = budget?.v3_deal_brackets || budget?.deal_brackets || [];

  if (operator !== 'AND') return null;
  if (!(summary.artistGuarantee > 0)) return null;
  if (!(summary.upsidePercentage > 0)) return null;
  if (summary.artistPercentage !== 0) return null;
  if ((offer?.revenue_base || 'default') !== 'default') return null;
  if (parseFloat(String(offer?.breakeven_threshold ?? '').replace(/[$,]/g, '')) > 0) return null;
  if (!fromDollarOne && dealBrackets.length > 0) return null;

  const amount = summary.artistGuarantee - summary.showNetAfterPromoterProfit;
  if (!(amount > 0)) return null;

  const grossPotential = sectionTotal(calculated.ticketsSection) + sectionTotal(calculated.revenueSection);

  return {
    amount,
    unreachable: summary.splitPoint > grossPotential,
    splitPoint: summary.splitPoint,
    grossPotential,
    guarantee: summary.artistGuarantee,
  };
};
